<div class="app-button-toggle-group-container">
  @if (label) {
    <div class="app-button-toggle-group-label"
         [ngClass]="{ 'text-danger': isError }">
      {{ isTranslate ? (label | translate) : label }}
      @if (isRequired) {*}
    </div>
  }
  <mat-button-toggle-group class="app-button-toggle-group"
                           appearance="legacy">
    @for (val of values; track $index) {
      <mat-button-toggle [value]="val[bindValue]"
                         matRipple
                         [checked]="control.value == val[bindValue]"
                         (click)="onToggleClick(val[bindValue])"
                         class="app-button-toggle-group-item">
        {{ isTranslate ? (val[bindLabel] | translate) : val[bindLabel] }}
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
</div>
